import { type ErrorEvent } from "@sentry/react";

export const isRelatedToEdgeTranslation = (event: ErrorEvent): boolean =>
  isACommonEdgeTranslationRelatedErrors(event.exception) &&
  breadcrumbsIncludesEdgeTranslation(event.breadcrumbs);

export const breadcrumbsIncludesEdgeTranslation = (
  breadcrumbs: ErrorEvent["breadcrumbs"],
): boolean =>
  Boolean(
    breadcrumbs?.some((bc) =>
      bc.data?.arguments?.some((arg: string) =>
        ["Edge Translation started", "Edge revert page translation."].includes(
          arg,
        )
      )
    ),
  );

export const isACommonEdgeTranslationRelatedErrors = (
  exception: ErrorEvent["exception"],
): boolean =>
  Boolean(
    exception?.values?.some(
      (v) =>
        (v.type === "NotFoundError" &&
          v.value === "The object can not be found here.") ||
        (v.type === "TypeError" &&
          v.value === "Properties can only be defined on Objects."),
    ),
  );
